import React from 'react'
import { Route } from 'react-router-dom'
import MainClientManagement from '../Views/Web/Client Management/MainClientManagement'
import { IndexSurveyReport, SurveyReportCreate, SurveyReportEdit, SurveyReportMain, SurveyReportsView, ViewForm, Equipments, OpenForm, DummyForms } from '../Views/Web/Client Management/SurveyReport'
import { ContractsCreate, ContractsEdit, ContractsMain, ContractsView, EquipmentsContract, FormContract, IndexContract, InspectionContract, InvoiceContract, ServiceContract } from '../Views/Web/Client Management/Contracts'
import { IndexRenewal, RenewalCreate, RenewalEdit, RenewalMain, RenewalView } from '../Views/Web/Client Management/Renewal'
import MainContractManagement from '../Views/Web/Client Management/MainContractManagement'
import { IndexQuotes, QuotesCreate, QuotesEdit, QuotesMain, QuotesView } from '../Views/Web/Client Management/Quotes/Index'
import EquipDetailsIndex from '../Views/Web/Client Management/EquipDetails/EquipIndex'
import { IndexEquip } from '../Views/Web/Client Management/EquipDetails'
import { IndexSchedulesTesting, SchedulesTestingCreate, SchedulesTestingEdit, SchedulesTestingMain, SchedulesTestingview } from '../Views/Web/TestingAndCommissioning/Schedules/Index'
import Forms from '../Views/Web/TestingAndCommissioning/Schedules/Forms'

import { FireSuppressionCreate, FireSuppressionEdit, FireSuppressionMain, FireSuppressionView, IndexFireSuppression } from '../Views/Web/CollectionAndReturn/FireSuppression/Index'
import { FireExtinguishersCreate, FireExtinguishersEdit, FireExtinguishersMain, FireExtinguishersView, IndexFireExtinguishers } from '../Views/Web/CollectionAndReturn/FireExtinguishers/Index'

import FormView from '../Views/Web/CollectionAndReturn/FireSuppression/FormView'
import EquipmentView from '../Views/Web/CollectionAndReturn/FireSuppression/EquipmentView'
import FeFormView from '../Views/Web/CollectionAndReturn/FireExtinguishers/FeFormView'
import FeEquipmentsView from '../Views/Web/CollectionAndReturn/FireExtinguishers/FeEquipmentsView'
import Equipdetail from '../Views/Web/Client Management/EquipDetails/Equipdetail'
function ContractManagement() {
  return (
     <Route path="Contract-management" element={<MainContractManagement />}>
          
         <Route path="survey-report" element={<SurveyReportMain/>} >
           <Route index element={<IndexSurveyReport/>} />   
           <Route path='create' element={<SurveyReportCreate/>} />
           <Route path='edit/:surveyReportEditId' element={<SurveyReportEdit/>} />
           <Route path='view/:surveyReportViewId' element={<SurveyReportsView/>} />
           <Route path='form/:surveyReportViewId' element={<ViewForm/>} />
           {/* <Route path='form/:surveyReportViewId' element={<DummyForms/>} /> */}

           {/* <Route path='formOpen/:surveyReportViewId' element={<OpenForm/>} />*/}

           <Route path='equipments/:surveyReportViewId' element={<Equipments/>} /> 

          </Route>
         
         <Route path="contracts" element={<ContractsMain/>} >
  <Route index element={<IndexContract/>} />
  <Route path='create' element={<ContractsCreate/>} />
  <Route path='edit/:contractsEditId' element={<ContractsEdit/>} />
  <Route path='view/:contractsViewId' element={<ContractsView/>} />
  <Route path='form/:contractsViewId' element={<FormContract/>} />

  <Route path='equipments/:contractsViewId' element={<EquipmentsContract/>} />
  <Route path='equipments/:contractsViewId/equipDetails/:id' element={<IndexEquip/>} />
  <Route path='equipments/:contractsViewId/details/:id' element={<IndexEquip/>} />

  

  <Route path='inspection/:contractsViewId' element={<InspectionContract/>} />
  <Route path='invoice/:contractsViewId' element={<InvoiceContract/>} />
  <Route path='service/:contractsViewId' element={<ServiceContract/>} />
</Route>


 <Route path="quotes" element={<QuotesMain/>} >
           <Route index element={<IndexQuotes/>} />
           <Route path='create' element={<QuotesCreate/>} />
           <Route path='edit/:quotesEditId' element={<QuotesEdit/>} />
           <Route path='view/:quotesViewId' element={<QuotesView/>} />
           
          </Route>

          <Route path="renewal" element={<RenewalMain/>} >
           <Route index element={<IndexRenewal/>} />
           <Route path='create' element={<RenewalCreate/>} />
           <Route path='edit/:renewalEditId' element={<RenewalEdit/>} />
           <Route path='view/:renewalViewId' element={<RenewalView/>} />
          </Route>

           <Route path="fireExtinguisher" element={<FireExtinguishersMain/>} >
           <Route index element={<IndexFireExtinguishers/>} />
           <Route path='create' element={<FireExtinguishersCreate/>} />
           <Route path='edit/:fireExtinguishersEditId' element={<FireExtinguishersEdit/>} />
           <Route path='view/:fireExtinguishersViewId' element={<FireExtinguishersView/>} />
           <Route path='form/:fireExtinguishersViewId' element={<FeFormView/>} />
           <Route path='equipments/:fireExtinguishersViewId' element={<FeEquipmentsView/>} />
          
          </Route>
         <Route path="fireSuppression" element={<FireSuppressionMain/>} >
           <Route index element={<IndexFireSuppression/>} />
           <Route path='create' element={<FireSuppressionCreate/>} />
           <Route path='edit/:fireSuppressionEditId' element={<FireSuppressionEdit/>} />
           <Route path='view/:fireSuppressionViewId' element={<FireSuppressionView/>} />
           <Route path='form/:fireSuppressionViewId' element={<FormView/>} />
           <Route path='equipment/:fireSuppressionViewId' element={<EquipmentView/>} />

          </Route>  

                    <Route path="schedules" element={<SchedulesTestingMain/>} >
           <Route index element={<IndexSchedulesTesting/>} />
           <Route path='create' element={<SchedulesTestingCreate/>} />
           <Route path='edit/:scheduleEditId' element={<SchedulesTestingEdit/>} />
           <Route path='view/:scheduleViewId' element={<SchedulesTestingview/>} />
           <Route path='forms/:scheduleViewId' element={<Forms/>} />

          </Route>
          
      </Route>
  )
}

export default ContractManagement